<template>
  <v-container grid-list-lg fluid>
    <v-alert
      v-if="selectedCustomer"
      border="left"
      type="error"
      transition="slide-y-transition"
      dismissible
      class="mb-1"
      v-model="selectedCustomer.alert"
      color="red"
    >
      <strong>{{ selectedCustomer.note }}</strong>
    </v-alert>
    <v-layout column>
      <v-flex>
        <v-card outlined>
          <v-toolbar dense flat color="grey lighten-3">
            <v-toolbar-title>
              Edit Invoice <span># {{ Invoice.localId }}</span>
            </v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-row justify="end">
              <v-col class="shrink">
                <v-btn
                  color="pink"
                  small
                  dark
                  :loading="loading"
                  :disabled="InvoiceDetails.length === 0"
                  @click="saveInvoice"
                  >{{ invoiceTotal | currency }} update</v-btn
                >
              </v-col>
              <v-col class="shrink">
                <v-btn small text @click.stop.prevent="cancel">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
          <CustomerSection
            :initInvoice="initInvoice"
            :initValue="initValue"
            :initDonor="initDonor"
            :initCamp="initCamp"
            :isCustomer="isCustomer"
          />
        </v-card>
      </v-flex>
      <v-flex>
        <ProductSearchBar @submit="addRow" />
      </v-flex>
      <v-flex>
        <Cart />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import invoiceService from "../service";
import ProductSearchBar from "@/modules/Invoice/components/ProductSearchBar";
import Cart from "@/modules/Invoice/components/Cart";
import productService from "@/modules/Product/service.js";
import CustomerSection from "@/modules/Invoice/components/CustomerSection.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "create-invoice",
  data() {
    return {
      initDonor: null,
      initInvoice: null,
      initCamp: null,
      loading: false,
      initValue: null,
      isCustomer: false,
    };
  },
  components: {
    Cart,
    CustomerSection,
    ProductSearchBar,
  },
  computed: {
    ...mapGetters("invoice", [
      "Invoice",
      "InvoiceDetails",
      "invoiceTotal",
      "getEditInvoiceId",
      'getSelectedCustomer',
      "getSelectedCampaign",
    ]),
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
  },
  created() {
    // console.log("Invoice", this.Invoice);
    if (!this.Invoice.localId) {
      this.loadData();
    }
  },
  methods: {
    ...mapActions("invoice", [
      "AddInvoiceDetail",
      "ResetInvoice",
      "loadInvoice",
      "SetEditInvoiceId",
      "SetSelectedCustomer"
    ]),
    cancel() {
      if (this.InvoiceDetails.length > 0) {
        this.$swal({
          title: "Are you sure?",
          text: "You want to cancel this invoice",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            this.ResetInvoice();
            this.$router.go(-1);
          }
        });
      } else {
        this.ResetInvoice();
        this.$router.go(-1);
      }
    },
    async saveInvoice() {
      if (this.isCustomer) {
        this.Invoice.CustomerId = this.selectedCustomer.id
        if (!this.Invoice.CustomerId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Parent");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Parent is not selected!",
            });
          return false;
        }
      } else {
        this.Invoice.DonorId = this.selectedCustomer.id
        if (!this.Invoice.DonorId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Donor");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Donor is not selected!",
            });
          return false;
        }
      }
      if (this.InvoiceDetails) {
        this.loading = true;
        let saveInvoice = this.Invoice;
        if(this.getSelectedCampaign)
          saveInvoice.CampaignId = this.getSelectedCampaign.id
        // let localInvoiceDetail = []
        // await Promise.all(this.InvoiceDetails.map(detail => {
        //   console.log('detail', detail)
        //   if (!detail.delete) {
        //     localInvoiceDetail.push(detail)
        //   }
        // }))

        // saveInvoice.InvoiceDetails = localInvoiceDetail // this.InvoiceDetails;
        saveInvoice.InvoiceDetails = this.InvoiceDetails;
        console.log("localInvoiceDetail", saveInvoice, this.getEditInvoiceId);
        return invoiceService
          .update(this.getEditInvoiceId, saveInvoice)
          .then((updateSave) => {
            console.log("updateSave", updateSave);
            productService.resetCache();
            this.ResetInvoice();
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Invoice was Updated!",
              });
            this.loading = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            console.log("error on upadting invoice", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
    loadData() {
      console.log("load data");
      const { id } = this.$route.params;
      return invoiceService.getById(id).then((response) => {
        console.log("responseresponseresponse", response);
        this.initCamp = response.data.Campaign;
        this.initDonor = response.data.Donor;
        this.initInvoice = response.data;
        this.loadInvoice(response.data);
        this.SetEditInvoiceId(response.data.id);
        if (response.data.DonorId) {
          this.isCustomer = false
          this.initValue = response.data.Donor;
          this.selectedCustomer = response.data.Donor
        }
        if (response.data.CustomerId) {
          this.isCustomer = true
          this.initValue = response.data.Customer
          this.selectedCustomer = response.data.Customer
        }

        return response;
      });
    },
    addRow(val) {
      if (val) {
        this.AddInvoiceDetail({
          ProductId: val.id,
          name: val.Bar.name,
          price: val.Bar.price,
          total: val.Bar.price * val.Bar.qty,
          qty: val.Bar.qty,
          cost: val.cost | 0,
          imeiNumber: val.imeiNumber,
        });
      }
    },
  },
};
</script>

<style scoped></style>
